'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorShortText = function EditorShortText(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 9h16v2H4zm0 4h10v2H4z' })
  );
};
EditorShortText = (0, _pure2.default)(EditorShortText);
EditorShortText.displayName = 'EditorShortText';
EditorShortText.muiName = 'SvgIcon';

exports.default = EditorShortText;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/editor/short-text.js
 ** module id = 1948
 ** module chunks = 0
 **/